import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';

import { isRtl } from 'modules/language/selectors/language';
import requestsStatuses from 'modules/common/constants/requestsStatuses';
import { hideAppointmentInfo } from 'modules/queues/common/actions/appointmentInfo';
import { fetchAppointment } from 'modules/appointmentInfo/actions/fetchAppointment';
import { conferenceInProgress } from 'modules/conference/selectors/consultationInfo';
import { canCloseAppointment } from 'modules/appointmentInfo/selectors/currentAppointment';

import AppointmentInfoSidebar from './AppointmentInfoSidebar';

const mapStateToProps = (state) => ({
  rtl: isRtl(),
  canCloseAppointment: canCloseAppointment(state),
  isNeedToShowBackButton: !conferenceInProgress(state),
  appointmentId: state.queues.common.appointmentInfo.appointmentId,
  isGroupAppointmentFetching: state.appointmentInfo.currentAppointment.fetchGroupedStatus === requestsStatuses.pending,
});

export default compose(
  connect(
    mapStateToProps,
    { hideAppointmentInfo, fetchAppointment },
  ),

  lifecycle({
    componentWillReceiveProps({ appointmentId, isGroupAppointmentFetching }) {
      if (appointmentId !== this.props.appointmentId && !isGroupAppointmentFetching) {
        this.props.fetchAppointment(appointmentId, false);
      }
    },

    componentDidMount() {
      this.props.fetchAppointment(this.props.appointmentId, false);
    },
  }),
)(AppointmentInfoSidebar);
